import { Button, Input, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    ErrorItem,
    InputNumberItem,
    DatePickerItem,
} from "../../../../Components/Items";
import dayjs from "dayjs";

class EditarCarrera extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
    };

    async componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.setState({ loading: true })
            await axios
                .post(
                    "carreras/datosCarrera",
                    { empresaId: this.props.empresaId, carreraId: this.props.id },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false })
                    if (res.data.success === 2) {
                        this.formRef.current.setFieldsValue({
                            ...res.data.carrera,
                            fechaCarrera: dayjs(res.data.carrera.fechaCarrera),
                            fechaInicio: dayjs(res.data.carrera.fechaInicio),
                            fechaFin: dayjs(res.data.carrera.fechaFin),
                        });
                    } else {
                        message.error("Error no se encontro informacion de la carrera");
                    }
                });
        }
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "carreras/editarCarrera",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    carreraId: this.props.id
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Carrera editada exitosamente");
                    this.cerrarModalEditarCarrera();
                } else if (res.data.success === 1) {
                    message.error("No se pudo editar la carrera");
                } else {
                    message.error("Sucedió un error y no se pudo editar la carrera");
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    cerrarModalEditarCarrera() {
        this.setState({ visible: false });
        this.props.cerrarModalEditarCarrera();
        if (this.formRef.current) {
            this.formRef.current.resetFields();
        }
    }

    render() {
        return (
            <ModalItem
                title="Editar Carrera"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModalEditarCarrera.bind(this)}
                width={800}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="modalEditarCarrera"
                    layout
                    bottom={
                        <Button
                            type="primary"
                            htmlType="submit"
                            style={{ display: "block", margin: "0 0 0 auto" }}
                            loading={this.state.loading}
                        >
                            Guardar
                        </Button>
                    }
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormItem
                        label="Nombre"
                        name="nombre"
                        required
                    >
                        <Input placeholder="Nombre de la carrera" />
                    </FormItem>

                    <FormItem
                        label="Distancia (km)"
                        name="distancia"
                        required
                    >
                        <InputNumberItem min={1} placeholder="Distancia en kilómetros" style={{ width: "100%" }} />
                    </FormItem>

                    <FormItem
                        label="Precio ($)"
                        name="precio"
                        required
                    >
                        <InputNumberItem
                            placeholder="Precio de inscripción"
                            style={{ width: "100%" }}
                        />
                    </FormItem>

                    <FormItem
                        label="Fecha de la Carrera"
                        name="fechaCarrera"
                        required
                    >
                        <DatePickerItem />
                    </FormItem>

                    <FormItem
                        label="Hora de la Carrera"
                        name="horaCarrera"
                        required
                    >
                        <InputNumberItem placeholder="Hora de la Carrera" />
                    </FormItem>

                    <FormItem
                        label="Ubicación de la Carrera"
                        name="ubicacionCarrera"
                        required
                    >
                        <Input placeholder="Ubicación de la Carrera" />
                    </FormItem>

                    <FormItem
                        label="Fecha de Inicio de Inscripción"
                        name="fechaInicio"
                        required
                    >
                        <DatePickerItem />
                    </FormItem>

                    <FormItem
                        label="Fecha de Fin de Inscripción"
                        name="fechaFin"
                        required
                    >
                        <DatePickerItem />
                    </FormItem>

                    <FormItem
                        label="Observaciones"
                        name="observaciones"
                    >
                        <Input placeholder="Observaciones" />
                    </FormItem>

                </Form>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(EditarCarrera);
